const LEGAL_LINKS_BY_LANG = {
  'en-sg': {
    footer: {
      privacyPolicy:
        'https://www.singsaver.com.sg/page/singsaver-privacy-policy',
      termsAndConditions: 'https://www.singsaver.com.sg/page/singsaver-terms',
    },
  },
  'en-hk': {
    footer: {
      privacyPolicy:
        'https://www.moneyhero.com.hk/en/page/moneyhero-privacy-policy',
      termsAndConditions:
        'https://www.moneyhero.com.hk/en/page/moneyhero-terms',
    },
  },
  'zh-hk': {
    footer: {
      privacyPolicy:
        'https://www.moneyhero.com.hk/zh/page/moneyhero-privacy-policy',
      termsAndConditions:
        'https://www.moneyhero.com.hk/zh/page/moneyhero-terms',
    },
  },
} as const;

export function getLegalLinks(lang: string) {
  return (
    LEGAL_LINKS_BY_LANG[lang as keyof typeof LEGAL_LINKS_BY_LANG] ??
    LEGAL_LINKS_BY_LANG['en-sg']
  );
}
